import React from "react";
import { RoundedButton } from "@bloomberg/media-ui-core";
import { Tune } from "@bloomberg/media-ui-icons";

type ShowButtonProps = {
  onClick: () => void;
};

export const ShowButton = React.forwardRef<HTMLButtonElement, ShowButtonProps>(
  (props, ref) => {
    const { onClick } = props;

    return (
      <RoundedButton
        appearance="outline"
        size="small"
        iconPosition="right"
        colorMode="dark"
        onClick={onClick}
        ref={ref}
      >
        <Tune />
      </RoundedButton>
    );
  }
);
ShowButton.displayName = "ShowButton";
